import { useEffect, useState } from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { LaborChart } from "../components/site/LaborChart";
import { Rewards } from "../components/site/Rewards";
import { Booking } from "../components/site/Booking";
import { Footer } from "../components/site/Footer";
import { startLenis, scrollToId } from "../lib/smooth";

const MAP = { "Oil Changes": "Oil Change", "Engine & Transmission Swaps": "Engine / Transmission Swap", "& More": "Something else" };

export default function Landing() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  const bookService = (name) => {
    const s = MAP[name] ?? name;
    setServices((p) => (p.includes(s) ? p : [...p, s]));
    scrollToId("book");
  };
  const bookRepairs = (list) => {
    setServices((p) => Array.from(new Set([...p, ...list])));
    scrollToId("book");
  };

  return (
    <div className="relative bg-[var(--bg)] text-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services onBook={bookService} />
        <LaborChart onBookRepairs={bookRepairs} />
        <Rewards />
        <Booking services={services} setServices={setServices} />
      </main>
      <Footer />
    </div>
  );
}
